import { NotificationsState } from '../types';
import { createReducer } from '../helper';
import {
  IFieldErrorsAdded,
  ICommonErrorAdded,
  ActionType,
  IClearFieldError,
  IVerificationErrorAdded,
} from './notificationActions';

const initialState: NotificationsState = {
  commonErrors: [],
  fieldErrors: [],
  verificationErrors: [],
  invalidStepError: false,
};

const fieldErrorsAdded = (
  state: NotificationsState,
  action: IFieldErrorsAdded
) => ({
  ...state,
  fieldErrors: [...state.fieldErrors, ...action.errors],
});

const commonErrorAdded = (
  state: NotificationsState,
  action: ICommonErrorAdded
) => ({
  ...state,
  commonErrors: [...state.commonErrors, action.error],
});

const clearFieldError = (
  state: NotificationsState,
  action: IClearFieldError
) => ({
  ...state,
  fieldErrors: state.fieldErrors.filter((x) => x.property !== action.property),
});

const clearErrors = () => ({
  ...initialState,
});

const verificationErrorAdded = (
  state: NotificationsState,
  action: IVerificationErrorAdded
) => ({
  ...state,
  verificationErrors: [...state.verificationErrors, action.error],
});

const invalidStepErrorSet = (state: NotificationsState) => ({
  ...state,
  invalidStepError: true,
});

const clearInvalidStepError = (state: NotificationsState) => ({
  ...state,
  invalidStepError: false,
});

const handlers = {
  [ActionType.FIELD_ERRORS_ADDED]: fieldErrorsAdded,
  [ActionType.COMMON_ERROR_ADDED]: commonErrorAdded,
  [ActionType.CLEAR_ERRORS]: clearErrors,
  [ActionType.CLEAR_FIELD_ERRORS]: clearFieldError,
  [ActionType.VERIFICATION_ERROR_ADDED]: verificationErrorAdded,
  [ActionType.INVALID_STEP_ERROR_SET]: invalidStepErrorSet,
  [ActionType.CLEAR_INVALID_STEP_ERROR]: clearInvalidStepError,
};

export const notificationsReducer = createReducer<NotificationsState>(
  initialState,
  handlers
);
